import _objectWithoutProperties from "/home/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/home/runner/_work/miro-site/miro-site/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
var _excluded = ["document"];

var _renderMark, _renderNode;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import styled from 'styled-components';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { BLOCKS, INLINES, MARKS } from '@contentful/rich-text-types';
import { Bold, Box, Heading, Italic, Link, ListItem, OrderedList, Text, Underlined, UnorderedList } from '@miro-site/core';
import { jsx as _jsx } from "react/jsx-runtime";
var options = {
  renderMark: (_renderMark = {}, _defineProperty(_renderMark, MARKS.BOLD, function (text) {
    return /*#__PURE__*/_jsx(Bold, {
      children: text
    });
  }), _defineProperty(_renderMark, MARKS.ITALIC, function (text) {
    return /*#__PURE__*/_jsx(Italic, {
      children: text
    });
  }), _defineProperty(_renderMark, MARKS.UNDERLINE, function (text) {
    return /*#__PURE__*/_jsx(Underlined, {
      children: text
    });
  }), _renderMark),
  renderNode: (_renderNode = {}, _defineProperty(_renderNode, BLOCKS.HEADING_1, function (node, children) {
    return /*#__PURE__*/_jsx(Heading, {
      as: "h1",
      $variant: "h3",
      $mb: 40,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_2, function (node, children) {
    return /*#__PURE__*/_jsx(Heading, {
      as: "h2",
      $variant: "h3",
      $mb: 40,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_3, function (node, children) {
    return /*#__PURE__*/_jsx(Heading, {
      as: "h3",
      $variant: "h4",
      $mb: 24,
      $mt: 40,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_4, function (node, children) {
    return /*#__PURE__*/_jsx(Heading, {
      as: "h4",
      $variant: "h4",
      $mb: 24,
      $mt: 40,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_5, function (node, children) {
    return /*#__PURE__*/_jsx(Heading, {
      as: "h5",
      $variant: "h4",
      $mb: 24,
      $mt: 40,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.HEADING_6, function (node, children) {
    return /*#__PURE__*/_jsx(Heading, {
      as: "h6",
      $variant: "h4",
      $mb: 24,
      $mt: 40,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.PARAGRAPH, function (node, children) {
    return /*#__PURE__*/_jsx(Text, {
      $variant: "p1",
      $mb: 24,
      children: children
    });
  }), _defineProperty(_renderNode, BLOCKS.OL_LIST, function (node, children) {
    return /*#__PURE__*/_jsx(OrderedList, {
      $variant: "default",
      children: React.Children.map(children, function (child) {
        return /*#__PURE__*/_jsx(ListItem, {
          $variant: "p1",
          children: child
        });
      })
    });
  }), _defineProperty(_renderNode, BLOCKS.UL_LIST, function (node, children) {
    return /*#__PURE__*/_jsx(UnorderedList, {
      $variant: "default",
      children: React.Children.map(children, function (child) {
        return /*#__PURE__*/_jsx(ListItem, {
          $variant: "p1",
          children: child
        });
      })
    });
  }), _defineProperty(_renderNode, BLOCKS.LIST_ITEM, function (node, children) {
    return children;
  }), _defineProperty(_renderNode, INLINES.HYPERLINK, function (node, children) {
    return /*#__PURE__*/_jsx(Link, {
      href: node.data.uri,
      $variant: "richText",
      $size: "default",
      $color: "default",
      children: children
    });
  }), _renderNode)
};

var RichTextBase = function RichTextBase(_ref) {
  var document = _ref.document,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsx(Box, _objectSpread(_objectSpread({}, props), {}, {
    children: documentToReactComponents(document, options)
  }));
};

var RichText = styled(RichTextBase).withConfig({
  displayName: "RichText",
  componentId: "sc-v32vi7-0"
})(["", " *{color:currentColor;text-decoration:none;}"], Link);
export default RichText;